module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAKCAYAAACqnE5VAAAAZElEQVQ4jWNkQAOemwrt/zL8X8vMwBi83a//ILo8uYCRHpagWERLS+AW0doSBgYGBkaPzUV5//7/a2dkZFz5n+H/Q2pbwPyf8cB2v/6DTNQ2GBegX9DBGHRJDPSwjBFdgFaWAQCCrkUMUoWmLgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./resources/images/arrow_back_2x.png
// module id = 958
// module chunks = 0